import { observer } from 'mobx-react'
import { useFormContext, useWatch } from 'react-hook-form'
import { validatePassword } from 'API/user'
import Input from '../InputWithLabel'
import styles from './changePasswordSection.module.scss'

interface IChangePasswordSectionProps {
  isProfile?: boolean
  userId?: number
  /** Google-registered users who have not set a local password yet — collect new password only. */
  hideOldPassword?: boolean
}

const ChangePasswordSection = (props: IChangePasswordSectionProps) => {
  const { isProfile, userId, hideOldPassword } = props
  const { register, control } = useFormContext()
  const newPassword = useWatch({ name: 'newPassword', control })
  const showOldPasswordField = isProfile && userId && !hideOldPassword

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{hideOldPassword ? 'Set password' : 'Change password'}</h2>
      {hideOldPassword && (
        <p className={styles.hint}>Choose a password to sign in with email as well as Google.</p>
      )}
      <div className={styles.newPasswordWrapper}>
        {showOldPasswordField && (
          <Input
            {...register('oldPassword', {
              minLength: {
                value: 6,
                message: 'Must be at least 6 characters'
              },
              validate: {
                isMatched: async value => {
                  if (value) {
                    const result = await validatePassword(userId, value)
                    return result || 'Wrong password'
                  }
                  return true
                }
              }
            })}
            type="password"
            title="Old password"
            placeholder="Your old password"
            noPaddingTop
          />
        )}
        <Input
          {...register('newPassword', {
            minLength: {
              value: 6,
              message: 'Must be at least 6 characters'
            }
          })}
          type="password"
          title="New password"
          placeholder="Your new password"
        />
        <Input
          {...register('confirmPassword', {
            validate: (value: string) => !newPassword || value === newPassword || 'Password does not matched'
          })}
          type="password"
          title="Confirm new password"
          placeholder="Your new password"
        />
      </div>
    </div>
  )
}

export default observer(ChangePasswordSection)
